export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "select-placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select"])},
        "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])}
      },
      "fr": {
        "select-placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner"])},
        "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter"])}
      }
    }
  })
}
